'use client';

import { SlotEquivalentLinksItem } from '../Base/SlotEquivalentLinks.Item.client';
import { useServiceLink } from '../../shared/useServiceLink';

export const ServiceLink = () => {
  const { href, label } = useServiceLink();
  return (
    <SlotEquivalentLinksItem href={href}>
      <span className="icon-emp-service size-4" aria-hidden />
      <span className="hyphens-auto">{label}</span>
    </SlotEquivalentLinksItem>
  );
};
